import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import {
  INDUSTRY_MAPPINGS,
  LOCATION_MAPPINGS,
} from '../Business/pages/Businesses/constants';
import { getResolveUrl } from 'utils';

const URL_FILTER_MAPPING = { ...INDUSTRY_MAPPINGS, ...LOCATION_MAPPINGS };

export default function useHelmetInfo(page: string, isUrgent = false) {
  const { t } = useTranslation();

  const { pathname } = useLocation();

  const { urlFilter } = useParams<{ urlFilter: string }>();

  const titlePageSuffix = page
    ? `, ${t('pagPage', { count: +page })} | Resolve`
    : ' | Resolve';

  const businessesTitle = `${
    URL_FILTER_MAPPING[urlFilter as keyof typeof URL_FILTER_MAPPING]?.title ||
    t('businessesForSale')
  }${titlePageSuffix}`;

  const urgentTitle = `Urgent Listings${titlePageSuffix}`;

  const businessesDescription =
    URL_FILTER_MAPPING[urlFilter as keyof typeof URL_FILTER_MAPPING]
      ?.description ||
    'From small businesses to established enterprises, Resolve has a diverse range of businesses for sale. Start the chapter of your career or investment portfolio today.';

  const urgentDescription =
    'Browse urgent sale listings in Australia with Resolve.';

  const url = getResolveUrl(
    `${pathname.slice(-1) === '/' ? pathname.slice(0, -1) : pathname}${
      +page > 1 ? `?page=${page}` : ''
    }`,
  );

  return {
    url,
    title: isUrgent ? urgentTitle : businessesTitle,
    description: isUrgent ? urgentDescription : businessesDescription,
  };
}
